import { SET_ERROR, SET_ITEMS, REMOVE_BY_ID, ADD_ITEM, SET_USAGE, SET_ITEM } from '../mutation-types'

import Vue from 'vue'
import axios from 'axios'

import { add, remove } from '@/components/SelectComponent'

export default {
    namespaced: true,

    state: {
        data: [],
        meta: null,
        usage: {},
        error: null
    },

    getters: {
        data: state => state.data,
        meta: state => state.meta,
        filterbyId: state => id => state.data.find(item => item.id === id)
    },

    mutations: {
        [SET_ITEMS](state, { data, meta }) {
            state.data = data
            state.meta = meta
        },

        [ADD_ITEM](state, data) {
            state.data.unshift(data)
            add(data)
        },

        [SET_USAGE](state, { data }) {
            state.usage = data
        },

        [SET_ERROR](state, error = null) {
            state.error = error
        },

        [REMOVE_BY_ID](state, id) {
            const index = state.data.findIndex(component => component.id === id)

            if (index !== -1) {
                state.data.splice(index, 1)
            }

            remove(id)
        },

        [SET_ITEM](state, item) {
            const id = item.id
            const index = state.data.findIndex(item => item.id === id)

            if (index !== -1) {
                Vue.set(state.data, index, item)
            }

            remove(id)
            add(item)
        }
    },

    actions: {
        async fetchAll({ commit }, params) {
            try {
                let response = await axios.get('api/components', { params })
                commit(SET_ITEMS, response.data)
            } catch (error) {
                return false
            }

            return true
        },

        async fetchById({ getters }, id) {
            const component = getters.filterbyId(id)

            if (component) {
                return component
            }

            try {
                const response = await axios.get(`api/components/${id}`)

                return response.data
            } catch (error) {
                return null
            }
        },

        async store({ commit }, data) {
            commit(SET_ERROR)

            try {
                if (data.id) {
                    const response = await axios.put(`api/components/${data.id}`, data)
                    commit(SET_ITEM, response.data)

                    return response.data
                } else {
                    const response = await axios.post('api/components', data)
                    commit(ADD_ITEM, response.data)

                    return response.data
                }
            } catch (error) {
                if (error.response.status === 422) {
                    commit(SET_ERROR, error.response.data || {})
                }

                return false
            }
        },

        async remove({ commit }, id) {
            try {
                await axios.delete('api/components/' + id)
                commit(REMOVE_BY_ID, id)
            } catch (error) {
                return false
            }

            return true
        },

        async getUsage({ commit }, id) {
            try {
                let response = await axios.get(`api/components/${id}/usage`)
                commit('SET_USAGE', response)
            } catch (error) {
                return false
            }

            return true
        }
    }
}
